var exports = {
  "k": "container__FygNTe",
};

module.exports = exports;
